import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import './Announcement.css';
import { useModuleContext } from '../../context/ModuleProvider';
import Preloader from '../Preloader/Preloader';
import axiosInstance from '../../axiosapi';
import DatePicker from 'react-multi-date-picker';

function Announcement() {
  let { moduleId, url } = useModuleContext();
  let [announcement, setAnnouncement] = useState(null);
  let [loading, setLoading] = useState(false);
  const [values, setValues] = useState(['', '']);

  useEffect(() => {
    setLoading(true);
    axiosInstance({
      method: 'get',
      url: `${url}/announcement/?start_date=${values[0] ? values[0].format('YYYY-MM-DD') : ''}&end_date=${
        values[1] ? values[1].format('YYYY-MM-DD') : ''
      }`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    }).then((res) => {
      setLoading(false);
      setAnnouncement(res.data.announcement);
    });
  }, [values]);

  let colors = ['pink', 'green', 'orange'];

  return (
    <div className="w-100 px-sm-3 px-2" style={{ marginTop: '-17px' }}>
      <div className="key__dates">
        <div className="header">
          <div className="color-overlay">
            <div className="d-flex align-items-center">
              <div className="day-number">{moment().format('DD')}</div>
              <div className="date-right">
                <div className="day-name">{moment().format('dddd')}</div>
                <div className="month px-0">{moment().format('MMM YYYY')}</div>
              </div>
              <div className="today display-3 d-inline-block">Today</div>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <DatePicker
              value={values}
              onChange={setValues}
              range
              rangeHover
              render={(value, openCalendar) => (
                <div className="d-flex calendar-input">
                  <input
                    className="form-control pr-4"
                    value={value}
                    onClick={openCalendar}
                    placeholder="Select Date Range"
                  />
                  {!value ? (
                    <span onClick={openCalendar} className="calendar-icon">
                      <i className="fa fa-calendar" aria-hidden="true" />
                    </span>
                  ) : (
                    <span onClick={() => setValues(['', ''])} className="calendar-icon">
                      <i className="fa fa-remove" style={{ color: 'red' }} aria-hidden="true" />
                    </span>
                  )}
                </div>
              )}
            />
          </div>
        </div>
        <div className="timeline">
          <ul>
            {!loading ? (
              announcement && announcement.length !== 0 ? (
                announcement.map((a) => {
                  let { id, title, description, notifDate } = a;
                  return (
                    <li key={id}>
                      <div className={`bullet ${colors[id % 3]}`} />
                      <div className="time">{moment(notifDate).format('MMMM Do YYYY')}</div>
                      <div className="desc">
                        <h3>
                          <Link className="text-primary" to={`/${moduleId}/announcement/detail?id=${id}`}>
                            {title}
                          </Link>
                        </h3>
                        <h4>{description}</h4>
                      </div>
                    </li>
                  );
                })
              ) : (
                <div className="text-center">Announcement not found for the selected date.</div>
              )
            ) : (
              <Preloader />
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Announcement;
